<template>
    <v-popper
        ref="popper"
        :placement="placement"
        :offset="offset"
        :boundary="boundary"
        @visibleChange="onVisibleChange"
    >
        <div class="time-select-popper">
            <div
                v-spinner="loading"
                class="time-select-popper-bd"
            >
                <div
                    v-if="dateList.length !== 0"
                    slot="content"
                >
                    <v-radio-group
                        v-if="!multiple"
                        v-model="curRadioValue"
                        vertical
                    >
                        <v-radio
                            v-for="(item, index) in dateList"
                            :key="index"
                            :value="item.id"
                            name="time"
                        >
                            <time-select-popper-item :value="item" />
                        </v-radio>
                    </v-radio-group>
                    <v-checkbox-group
                        v-if="multiple"
                        v-model="selected"
                        vertical
                    >
                        <v-checkbox
                            v-for="(item, index) in dateList"
                            :key="index"
                            :value="item.id"
                        >
                            <time-select-popper-item :value="item" />
                        </v-checkbox>
                    </v-checkbox-group>
                </div>
                <div
                    v-else
                    class="tc time-no-data"
                >
                    暂无数据
                </div>
                <v-spinner />
            </div>
            <div class="time-select-popper-ft">
                <a
                    class="time-select-popper__link"
                    href="/tp/time/matTimeList"
                    target="_blank"
                >设置</a>
                <a
                    class="time-select-popper__link"
                    @click="refresh"
                >刷新</a>
                <div class="time-select-popper__button">
                    <v-button
                        :disabled="!checkConfirm"
                        status="primary"
                        @click="confirm"
                    >
                        确定
                    </v-button>
                    <v-button
                        status="default"
                        @click="cancel"
                    >
                        取消
                    </v-button>
                </div>
            </div>
        </div>
    </v-popper>
</template>

<script>
import { Popper } from 'vhtml-ui';
import utils from '@/utils/utils.js';
import TimeSelectPopperItem from './time-select-popper-item';

import mixins from './mixins';

export default {
  name: 'TimeSelectPopper',

  components: {
    TimeSelectPopperItem,
  },

  mixins: [mixins],

  component: {
    Popper,
  },

  props: {
    fetchUrl: {
      type: String,
      default: '/tp/navWpa/getAllMatTime',
    },
  },

  data() {
    return {
      // 日期时间条件
      dateList: [],
    };
  },

  methods: {
    fetchData(isRefresh = false) {
      this.loading = true;

      this.$ajax
        .get(this.fetchUrl)
        .then((res) => {
          if (res.code === 0) {
            (res.data.records || []).forEach((item) => {
              this.resolveData(item);
            });
            this.dateList = res.data.records || [];
            this.inited = true;

            if (isRefresh) this.$message.success('内容已刷新');
          } else {
            this.$message.error(res.message || '网络错误，请重试');
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message.error('网络错误，请重试');
          this.loading = false;
        });
    },

    refresh() {
      this.fetchData(true);
    },

    confirm() {
      let value = null;

      if (this.multiple) {
        const selectDetail = [];
        const selected = new Set(this.selected);
        this.dateList.forEach((item) => {
          if (selected.has(item.id)) {
            selectDetail.push(item);
          }
        });
        value = selectDetail;
      } else {
        this.dateList.forEach((item) => {
          if (item.id === this.curRadioValue) {
            value = item;
          }
        });
      }

      this.$emit('change', value);
      this.$refs.popper.hide();
    },
    /* 因为后台直接刷数据会带来风险，所以前端处理 */
    resolveData(data) {
      if (data.weekdays && data.weekdays.length) {
        const week = data.weekdays;
        week.map((item) => {
          if (item.days) {
            item.days = Array.isArray(item.days)
              ? item.days.map(val => parseInt(val, 10))
              : item.days.split(',').map(val => parseInt(val, 10));
          } else {
            item.days = [];
          }
          if (!item.intervals) {
            item.intervals = [];
          }
          item.intervals.forEach((obj) => {
            if (obj.beginTime.length === 8) {
              obj.beginTime = obj.beginTime.substr(0, 5);
            }
            if (obj.endTime.length === 8) {
              obj.endTime = obj.endTime.substr(0, 5);
            }
          });
          return item;
        });
      } else {
        data.weekdays = [];
      }
      // 老数据转为新数据
      if (data.type === 2) {
        // 1星期条件、2日期条件、3新版星期条件和日期条件
        const res = [];
        data.daytime.forEach((item) => {
          item.enable = true;
          res.push(...utils.oldTonewDate(item));
        });
        data.daytime = res;
        data.type = 3;
      }
      if (data.daytime && data.daytime.length) {
        const daytimes = data.daytime;
        daytimes.forEach((item) => {
          if (!item.intervals) {
            item.intervals = [];
          }
          item.intervals.forEach((obj) => {
            if (obj.beginTime.length === 8) {
              obj.beginTime = obj.beginTime.substr(0, 5);
            }
            if (obj.endTime.length === 8) {
              obj.endTime = obj.endTime.substr(0, 5);
            }
          });
          if (item.enable === 'true') {
            item.enable = true;
          } else if (item.enable === 'false') {
            item.enable = false;
          } else {
            item.enable = Boolean(item.enable);
          }
          if (!item.enable) {
            item.intervals = [];
          }
          item.description = item.description || '';
        });
      } else {
        data.daytime = [];
      }
      return this.showData(data);
    },
    /* 转为需要展示的数据 */
    showData(data) {
      const weekText = {
        1: '星期一',
        2: '星期二',
        3: '星期三',
        4: '星期四',
        5: '星期五',
        6: '星期六',
        7: '星期日',
      };
      // 去除空Weekdays条件
      const weekdays = data.weekdays.filter(item => item.days.length !== 0 && item.intervals.length !== 0);
      const { daytime } = data;
      /* 处理basicWorkdays */
      const textData = {
        weekdays: [],
        daytime: [],
        expand: false,
      };
      for (const obj of weekdays) {
        let str = '';
        const week = obj.days.sort((a, b) => a - b);
        const time = obj.intervals.sort((a, b) => a.beginTime - b.beginTime);
        if (week.length > 1 && week[week.length - 1] - week[0] === week.length - 1) {
          str += `${weekText[week[0]]}至${weekText[week[week.length - 1]]}`;
        } else {
          str += week.map(item => weekText[item]).join('，');
        }
        str += ' ';
        time.forEach((o, index) => {
          str += `${o.beginTime}至${o.endTime}`;
          if (time.length - 1 !== index) {
            str += '、';
          }
        });
        textData.weekdays.push(str);
      }
      /* 处理特殊日期回显 */
      for (const obj of daytime) {
        let str = '';
        const { startDate, endDate } = obj;
        const time = obj.intervals.sort((a, b) => a.beginTime - b.beginTime);
        if (startDate === endDate) {
          str += `${startDate} `;
        } else {
          str += `${startDate}至${endDate} `;
        }
        if (time.length === 0) {
          str += obj.enable ? '' : '全天不生效';
        } else {
          time.forEach((o, index) => {
            str += `${o.beginTime}至${o.endTime}`;
            if (time.length - 1 !== index) {
              str += '、';
            }
          });
        }
        str += ` ${obj.description}`;
        textData.daytime.push(str);
      }
      this.$set(data, 'detail', textData);
    },
  },
};
</script>

<style lang="less">
@import './style.less';
</style>
